import type { HexColor } from './types'

const HEX_6 = /^[0-9a-f]{6}$/
const HEX_3 = /^[0-9a-f]{3}$/

/**
 * Porta de entrada de qualquer cor vinda de fora — `digitalProduct.color` do
 * evento, campo de formulário do produtor.
 *
 * Devolve `null` em vez de lançar por decisão de contrato: a cor do evento é
 * dado de terceiro e chega no caminho de boot. Uma exceção aqui derrubaria a
 * tela em vez de cair no fallback, que é o comportamento correto para um
 * atributo cosmético ausente ou malformado.
 */
export const normalizeHexColor = (
  raw: string | null | undefined
): HexColor | null => {
  if (typeof raw !== 'string') return null

  const semEspaco = raw.trim().toLowerCase()
  if (!semEspaco) return null

  const digitos = semEspaco.startsWith('#') ? semEspaco.slice(1) : semEspaco

  if (HEX_6.test(digitos)) return `#${digitos}`
  if (HEX_3.test(digitos)) {
    // Índice em vez de desestruturação: o `target` do tsconfig não habilita
    // iteração de string, e desestruturar `digitos` falha o type-check.
    return `#${digitos[0]}${digitos[0]}${digitos[1]}${digitos[1]}${digitos[2]}${digitos[2]}`
  }

  return null
}
